// /src/contexts/AuthContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';
import { IUsuario } from '../types';
import { mockUsuarios } from '../mocks/usuarios';

interface AuthContextType {
  usuario: IUsuario | null;
  login: (email: string, password: string) => boolean;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [usuario, setUsuario] = useState<IUsuario | null>(null);

  const login = (email: string, password: string): boolean => {
    // Buscar usuario por email (sin validar contraseña en el prototipo)
    const usuarioEncontrado = mockUsuarios.find(u => u.email === email);
    
    if (usuarioEncontrado) {
      setUsuario(usuarioEncontrado);
      return true;
    }
    
    return false;
  };

  const logout = () => {
    setUsuario(null);
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  }
  return context;
};
